<template>
  <commonView />
</template>
<script>
import commonView from '../components/commonView.vue';
export default {
  name: 'BusinessPurchaseEntryInformDetail',
  components: { commonView },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
